import { Typography } from '@components/Typography';
import { X } from '@untitled-ui/icons-react';
import { SearchBox } from 'react-instantsearch';
export default function SearchInput(props) {
  return (
    <SearchBox
      placeholder="Search for hotels, events, trip ideas and more"
      classNames={{
        root: 'relative flex items-center space-x-4 = h-12 pl-4 pr-1 w-full',
        form: 'w-full',
        input:
          'absolute inset-0 w-full focus:outline-none text-brand-mothernature font-medium border focus:border-brand-mothernature  rounded-md py-2 px-2 !appearance-none  pl-24 ',
        submit: 'absolute left-4 top-3',
        reset: 'absolute right-4 top-3.5',
      }}
      submitIconComponent={({ classNames }) => (
        <div className="flex items-center  space-x-2 uppercase ">
          <Typography
            tag="p"
            size="text-base"
            weight="font-semibold"
            className="uppercase">
            SEARCH
          </Typography>
        </div>
      )}
      resetIconComponent={({ classNames }) => (
        <X className="size-5" role="presentation" />
      )}
      //label="Search"
    />
  );
}
